module.exports = __webpack_public_path__ + "static/media/online-payment.f16aab31.png";